import {Action} from "@ngrx/store";
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR: string = '[ecommerce performance report orders last year] Load Ecommerce Performance Report Orders Last Year';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_SUCCESS: string = '[ecommerce performance report orders last year] Load Ecommerce Performance Report Orders Last Year Success';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_FAIL: string = '[ecommerce performance report orders last year] Load Ecommerce Performance Report Orders Last Year Fail';

export class LoadEcommercePerformanceReportOrdersLastYear implements Action {
  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommercePerformanceReportOrdersLastYearSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_SUCCESS;

  constructor(public payload: {
    ordersDataLastYear: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePerformanceReportOrdersLastYearFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR_FAIL;

  constructor(public payload: any) {
  }

}


export type EcommercePerformanceReportOrdersLastYearAction = LoadEcommercePerformanceReportOrdersLastYear | LoadEcommercePerformanceReportOrdersLastYearSuccess | LoadEcommercePerformanceReportOrdersLastYearFail;
